// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { PromotionModel } from "@insite/client-framework/Types/ApiModels";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";

interface OwnProps {
    promo: PromotionModel | undefined;
    extendedStyles?: CartLinePromoLabelStyles;
}

export interface CartLinePromoLabelStyles {
    wrapper?: InjectableCss;
    promoIcon?: IconPresentationProps;
    promotionNameText?: TypographyPresentationProps;
}

export const cartLinePromoLabelStyles: CartLinePromoLabelStyles = {};

const CartLinePromoLabel = ({ promo, extendedStyles }: OwnProps) => {
    const [styles] = React.useState(() => mergeToNew(cartLinePromoLabelStyles, extendedStyles));

    if (!promo) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Icon {...styles.promoIcon} />
            <Typography {...styles.promotionNameText}>{promo.name}</Typography>
        </StyledWrapper>
    );
};

export default CartLinePromoLabel;
